import { Button, Dialog, Grid } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import useDialogAriaHidden from '../../hooks/useDialogAriaHidden';

export function IfscModal({
    showModal = false,
    extraClass = '',
    heading = 'NOTE',
    info1 = '',
    info2 = '',
    info3 = '',
    info4 = '',
    content1 = '',
    content2 = '',
    content3 = '',
    content4 = '',
    proceedBtn = '',
    cancelBtn = '',
    proceedHref = '',
    mobileOrEmail = '',
    onCancel = () => {},
    ...props
}) {
    const [show, setShow] = useState<boolean>(showModal);
    const headingRef = useRef<HTMLHeadingElement>(null);
    const headingId = 'ifsc-modals-heading';

    useEffect(() => {
        setShow(showModal);
        if (showModal) {
            headingRef.current?.focus();
        }
    }, [showModal]);

    useDialogAriaHidden(show);

    const onProceed = () => {
        if (!!props.onProceed && typeof props.onProceed === 'function') {
            props.onProceed();
            return;
        }
        props.push(proceedHref);
    };

    return (
        <Dialog
            maxWidth={'sm'}
            open={show}
            role="dialog"
            aria-modal="true"
            aria-labelledby={headingId}
        >
            <div className={`note-modals ${extraClass}`}>
                <h3 id={headingId} ref={headingRef} tabIndex={-1}>
                    {heading}
                </h3>
                <Grid container>
                    <Grid item xs={12} sm={4}>
                        <p
                            style={{
                                wordBreak: 'break-word',
                            }}
                        >
                            {info1}
                        </p>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <p
                            style={{
                                wordBreak: 'break-word',
                            }}
                        >
                            {content1}
                        </p>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={4}>
                        <p
                            style={{
                                wordBreak: 'break-word',
                            }}
                        >
                            {info2}
                        </p>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <p
                            style={{
                                wordBreak: 'break-word',
                            }}
                        >
                            {content2}
                        </p>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={4}>
                        <p
                            style={{
                                wordBreak: 'break-word',
                            }}
                        >
                            {info3}
                        </p>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <p
                            style={{
                                wordBreak: 'break-word',
                            }}
                        >
                            {content3}
                        </p>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={4}>
                        <p
                            style={{
                                marginBottom: 10,
                                wordBreak: 'break-word',
                            }}
                        >
                            {info4}
                        </p>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <p
                            style={{
                                marginBottom: 10,
                                wordBreak: 'break-word',
                            }}
                        >
                            {content4}
                        </p>
                    </Grid>
                </Grid>
                <div className="note-modals-btns">
                    <Button className="customBtn" onClick={onProceed}>
                        {proceedBtn}
                    </Button>
                    {!!cancelBtn && (
                        <Button
                            className="customBtn cancelBtn"
                            onClick={() => {
                                setShow(!show);
                                onCancel();
                            }}
                        >
                            {cancelBtn}
                        </Button>
                    )}
                </div>
            </div>
        </Dialog>
    );
}
